import Link from "next/link";
import { Success } from "@chef/icons/symbol";
import { Card, Button } from "@chef/components";
import { AppShell } from "@chef/feature-app-shell";
import { BRAND_PATHS } from "@chef/constants";
import { DeliveryCutoffBanner } from "../../../components/DeliveryCutoffBanner";
import { intl } from "./CancelSubscriptionSuccessPage.Intl";

export const CancelSubscriptionSuccessPage = () => {
  return (
    <AppShell title={intl.UNSUBSCRIBE}>
      <AppShell.Meta />

      <AppShell.Header />
      <AppShell.AccountPausedBanner />
      <AppShell.OldVippsBanner />

      <DeliveryCutoffBanner />

      <AppShell.Main grid className="text-center">
        <div className="flex flex-col col-span-4 p-6 px-8 mx-auto mb-2 md:px-0 xl:col-span-6 xl:col-start-4 md:col-span-4 md:col-start-3">
          <div className="flex justify-center mx-auto ">
            <Success className="w-20 h-20" />
          </div>
          <h1 className="pt-10 mb-2 text-2xl ">
            <strong>{intl.FINISHED}</strong>
          </h1>
          <p>
            <strong>{intl.YOUR_DELIVERIES_ARE_STOPPED}</strong>
          </p>
          <p className="px-10 mb-8">
            {intl.WOULD_NOT_RECEIVE_DELIVERIES_UNTIL_REACTIVATE_ACC}{" "}
            {intl.WE_HOPE_TO_SEE_YOU_BACK}
          </p>
          <Link href={BRAND_PATHS.MY_SUBSCRIPTION_LINK} passHref legacyBehavior>
            <Button
              className="mx-auto mt-4 bg-transparent w-max md:mb-0"
              outlined
            >
              {intl.TO_MY_ACCOUNT}
            </Button>
          </Link>
        </div>

        <Card className="flex flex-col col-span-4 p-6 md:col-span-4 md:col-start-3 xl:col-span-6 xl:col-start-4 ">
          <p>
            <strong>{intl.CHANGED_YOUR_MIND}</strong>
          </p>
          <p>{intl.YOU_CAN_REACTIVATE_ANYTIME}</p>
          <Link href={BRAND_PATHS.MY_SUBSCRIPTION_LINK} passHref legacyBehavior>
            <Button className="mx-auto mt-4 w-max md:mb-0" primary>
              {intl.REACTIVATE}
            </Button>
          </Link>
        </Card>
      </AppShell.Main>
      <AppShell.TabBar />
    </AppShell>
  );
};
